module.exports = __webpack_public_path__ + "static/headerlogo-w-64b7a346c66e03c24080d0b534834023.png";